import { inject, Injectable, Injector } from '@angular/core';
import { createEntityState, GenericEntityStateClass, LoadMany } from '../../../core/state/entity.state';
import { LearningSectionContainerEntity } from '../learning-section-container-entity';
import { EntityService } from '../../../core/services/entity.service';
import { LearningSectionEntityService } from '../../services/learning-section.entity.service';
import { LearningSectionContainerContentService } from './learning-section-container-content.entity.service';
import { BaseEntity } from '../../../core/entities/base.entity';

export const STATE_NAME = 'learningSectionContainerEntity';

export const LearningSectionContainerEntityState: GenericEntityStateClass<LearningSectionContainerEntity> =
  createEntityState<LearningSectionContainerEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class LearningSectionContainerEntityService extends EntityService<LearningSectionContainerEntity> {
  private injector = inject(Injector);
  private learningSectionContainerContentService = inject(LearningSectionContainerContentService);

  constructor() {
    super();
    this.resourceType = 'learning-section-containers';
    this.stateClass = LearningSectionContainerEntityState;

    this.registerLazyRelation(
      'learning-sections',
      () => this.injector.get(LearningSectionEntityService)
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (state: any) => {
      const slice = state[STATE_NAME];
      return this.stateClass.allByQuery(slice, { query });
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected override async afterLoad(normalized: Record<string, any>, query?: Record<string, any>): Promise<void> {
    const contentService = this.learningSectionContainerContentService;

    for (const resourceType of Object.keys(normalized)) {
      if (resourceType === this.resourceType) continue; // skip container

      const entities = normalized[resourceType] as Record<string, BaseEntity>;
      if (!entities) continue;

      const service = contentService.getService(resourceType);
      if (!service) continue;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const stateName = (service.stateClass as any).stateName;

      const filteredEntities: Record<string, BaseEntity> = {};
      for (const [id, entity] of Object.entries(entities)) {
        if (id === query?.id || id === undefined) continue; // skip container
        filteredEntities[id] = entity;
      }

      if (Object.keys(filteredEntities).length > 0) {
        this.store.dispatch(
          new LoadMany({
            entities: filteredEntities,
            query: { from: this.resourceType, morph: 'content' },
            stateName,
            relationKeys: [],
          })
        );
      }
    }
  }
}
